import React from "react";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    totalItems: number;
    pageSize: number;
}

const Pagination: React.FC<PaginationProps> = ({
    currentPage,
    totalPages,
    onPageChange,
    // totalItems,
    // pageSize
}) => {
    const getVisiblePages = () => {
        const delta = 2;
        const range: (number | string)[] = [];
        const rangeWithDots: (number | string)[] = [];

        for (let i = Math.max(2, currentPage - delta); i <= Math.min(totalPages - 1, currentPage + delta); i++) {
            range.push(i);
        }

        if (totalPages <= 1) {
            return [1];
        }

        if (currentPage - delta > 2) {
            rangeWithDots.push(1, "...");
        } else {
            rangeWithDots.push(1);
        }

        rangeWithDots.push(...range);

        if (currentPage + delta < totalPages - 1) {
            rangeWithDots.push("...", totalPages);
        } else {
            rangeWithDots.push(totalPages);
        }

        return rangeWithDots;
    };

    const visiblePages = getVisiblePages();

    const handleChange = (page: number) => {
        if (page < 1 || page > totalPages || page === currentPage) return;
        onPageChange(page);
    };

    return (
        <div className="bg-white rounded-xl shadow-sm p-4">
            {/* Page Info */}
            <div className="flex justify-center items-center mb-4">
                <span className="text-sm text-gray-600">
                    Page {currentPage} sur {Math.max(totalPages, 1)}
                </span>
                {/* <span className="text-sm text-gray-600">
                    {totalItems === 0
                        ? 0
                        : (currentPage - 1) * pageSize + 1}
                    -{Math.min(currentPage * pageSize, totalItems)} sur {totalItems}
                </span> */}
            </div>

            {/* Pagination Controls */}
            <div className="flex justify-center items-center gap-2">
                {/* Previous Button */}
                <button
                    onClick={() => handleChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className={`p-2 rounded-lg ${currentPage === 1 ? "bg-gray-100 cursor-not-allowed" : "bg-primary-secondary hover:bg-primary-tertiary"
                        }`}
                    aria-label="Page précédente"
                >
                    <IoChevronBack
                        size={20}
                        color={currentPage === 1 ? "#9ca3af" : "#3b82f6"}
                    />
                </button>

                {/* Page Numbers */}
                <div className="flex gap-1">
                    {visiblePages.map((page, index) => (
                        <React.Fragment key={`${page}-${index}`}>
                            {page === "..." ? (
                                <div className="px-3 py-2 select-none">
                                    <span className="text-gray-400">...</span>
                                </div>
                            ) : (
                                <button
                                    onClick={() => handleChange(page as number)}
                                    className={`px-3 py-2 rounded-lg ${currentPage === page
                                        ? "bg-primary-secondary hover:bg-primary-tertiary"
                                        : "bg-gray-100 hover:bg-gray-200"
                                        }`}
                                    aria-current={currentPage === page ? "page" : undefined}
                                >
                                    <span
                                        className={`text-sm font-medium ${currentPage === page ? "text-white" : "text-gray-700"
                                            }`}
                                    >
                                        {page}
                                    </span>
                                </button>
                            )}
                        </React.Fragment>
                    ))}
                </div>

                {/* Next Button */}
                <button
                    onClick={() => handleChange(currentPage + 1)}
                    disabled={currentPage === totalPages || totalPages === 0}
                    className={`p-2 rounded-lg ${currentPage === totalPages || totalPages === 0
                        ? "bg-gray-100 cursor-not-allowed"
                        : "bg-primary-tertiary hover:bg-primary-secondary/40"
                        }`}
                    aria-label="Page suivante"
                >
                    <IoChevronForward
                        size={20}
                        color={currentPage === totalPages || totalPages === 0 ? "#FF8C42" : "#FF6B1A"}
                    />
                </button>
            </div>
        </div>
    );
};

export default Pagination; 